<template>
  <v-container class="pa-0">
    <v-row>
      <v-col class="pa-0">
        <v-textarea
          v-model="comment"
          label="Votre commentaire"
          :placeholder="textareaLabel"
          persistent-placeholder
          outlined
          required
          auto-grow
          hide-details
          rows="4"
          :autofocus="autofocus"
          color="primary darken-1"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: `InterventionUpdateComment`,
  props: {
    value: String,
    required: {
      type: Boolean,
      default: true,
    },
    autofocus: Boolean,
    label: {
      type: String,
      default: ``,
    },
  },
  data: () => ({
  }),
  computed: {
    comment: {
      get() { return this.value; },
      set(value) { return this.$emit(`input`, value); },
    },
    textareaLabel() {
      if (this.label !== ``) {
        return this.label;
      }
      return `Votre commentaire${this.required ? `*` : ` (optionnel)`}`;
    },
  },
};
</script>

<style lang="scss">
</style>
